let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gqMsh")).then(() => parcelRequire('kwT2K'));